import { ManageTeamsCtrl, TeamFormCtrl, TeamsCtrl, TeamService, OrganizationCtrl, OrganizationChartCtrl } from ".";

const teamsCoreMod = angular
  .module("teamsCore", [])
  .service("TeamService", TeamService)
  .controller("TeamsCtrl", TeamsCtrl)
  .controller("OrganizationCtrl", OrganizationCtrl)
  .controller("OrganizationChartCtrl", OrganizationChartCtrl)
  .controller("ManageTeamsCtrl", ManageTeamsCtrl)
  .controller("TeamFormCtrl", TeamFormCtrl);
export default teamsCoreMod.name;
